import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../services/store';
import { PURGE } from 'redux-persist';

const initialState = {
  used: 0,
  limit: 0,
  file: 0,
  video: 0,
};

export const storageSlice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    storageChanged: (state, { payload }) => {
      state.used = payload.used;
      state.limit = payload.limit;
      state.file = payload.file;
      state.video = payload.video;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { storageChanged } = storageSlice.actions;

export const selectStorage = (state: RootState) => state.storage;

export default storageSlice.reducer;
